import { render, staticRenderFns } from "./ProductOrderedProductsTable.vue?vue&type=template&id=90bcc89e&"
import script from "./ProductOrderedProductsTable.vue?vue&type=script&lang=js&"
export * from "./ProductOrderedProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/ProductOrderedProductsTable.vue
// module id = null
// module chunks = 